/**
 * Module-level access-token store. IN MEMORY ONLY — never `localStorage`, `sessionStorage`, or a
 * cookie (Option A invariant). The CSRF token captured from the refresh body lives here too and is
 * cleared on sign-out. Nothing here decodes the token: identity comes from `GET /v1/me`.
 */
interface StoreState {
  token: string | null;
  expiresAt: string | number | null;
  csrfToken: string | null;
}

const state: StoreState = { token: null, expiresAt: null, csrfToken: null };
let signOutCallback: ((expired: boolean) => void) | null = null;

export function getAccessToken(): string | null {
  return state.token;
}
export function getExpiresAt(): string | number | null {
  return state.expiresAt;
}
export function setAccessToken(
  token: string | null,
  expiresAt: string | number | null = null,
): void {
  state.token = token;
  state.expiresAt = expiresAt;
}
export function getCsrfToken(): string | null {
  return state.csrfToken;
}
export function setCsrfToken(token: string | null): void {
  state.csrfToken = token;
}
export function registerSignOutCallback(cb: ((expired: boolean) => void) | null): void {
  signOutCallback = cb;
}
/** Clear all in-memory auth state; `expired: true` marks a runtime session expiry (interstitial). */
export function signOut(opts?: { expired?: boolean }): void {
  state.token = null;
  state.expiresAt = null;
  state.csrfToken = null;
  signOutCallback?.(opts?.expired ?? false);
}
/** Test seam. */
export function __resetAuthStore(): void {
  state.token = null;
  state.expiresAt = null;
  state.csrfToken = null;
  signOutCallback = null;
}
